var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivitycenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icons / Navigation icon (12 states)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 372",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H3a1 1 0 01-1-1V8.5a2 2 0 012-2h4V4a2 2 0 012-2h4a2 2 0 012 2v7h4a2 2 0 012 2v8a1 1 0 01-1 1zm5-2v-7h-4v7zm-10 0h4v-7-9h-4zm-6 0h4V8.5H4z",
    fill: "#fff"
  })));
}

export default SvgActivitycenter;


//////////////////
// WEBPACK FOOTER
// ./src/icons/activity center.svg
// module id = 887
// module chunks = 101